import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class DirectorPartingList extends ShadowDOMElement {
	static className = "DirectorPartingList";
	
	static properties = {
		title: {type: String, attribute: "title"},
		textLabel : {title: String, attribute: "text-label"},
		buttonLabel : {title: String, attribute: "button-label"}
	};

	constructor() {
		super();
		this.partingDirectors = [];
		this.title = "Directeur";
		this.textLabel = "Directeur partant *";
		this.buttonLabel = "Ajouter un directeur partant";
	}

	firstUpdated() {
		super.firstUpdated();
		this.addDirectorPartingField();
	}

	addDirectorPartingField() {
		const directorPartingField = document.createElement("director-parting-field");
		directorPartingField.setAttribute ("title", this.title);
		directorPartingField.setAttribute ("text-label", this.textLabel);

		if (this.partingDirectors.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(() => {
				this.removeDirectorPartingField(directorPartingField, deleteButtonWrapper);
			});
			this.appendChild (deleteButtonWrapper);
		}

		this.partingDirectors.push(directorPartingField);
		this.appendChild (directorPartingField);
	}

	removeDirectorPartingField(directorPartingField, deleteButtonWrapper) {
		this.partingDirectors = this.partingDirectors.filter(
			(director) => director !== directorPartingField
		);
		this.removeChild(directorPartingField);
		if (deleteButtonWrapper)
			this.removeChild(deleteButtonWrapper);
	}

	createDeleteButton(deleteHandler) {
		const deleteButtonWrapper = document.createElement("row-wrapper");
		const deleteButton = document.createElement("button-field");

		deleteButton.onClickHandler = deleteHandler;
		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;

		deleteButtonWrapper.appendChild(deleteButton);
		return deleteButtonWrapper;
	}

	render() {
		return html`
		<slot></slot>
		<row-wrapper data-add-button="true">
			<button-field .onClickHandler="${this.addDirectorPartingField.bind(this)}">
				<i class="fa fa-plus"></i><span>&nbsp;${this.buttonLabel}</span>
			</button-field>
		</row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}

	getValues (){
		return {
			"count" : this.partingDirectors.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.partingDirectors.length < values.count)
	        this.addDirectorPartingField ();
		super.setValues (values);
	}
}

customElements.define("director-parting-list", DirectorPartingList);
